import slotifyLogo from "@/assets/slotify-logo.svg";

interface SlotifyLogoProps {
  className?: string;
  showText?: boolean;
  textClassName?: string;
}

const SlotifyLogo = ({ className = "h-8", showText = false, textClassName }: SlotifyLogoProps) => {
  return (
    <div className="flex items-center gap-2">
      <img src={slotifyLogo} alt="Slotify" className={className} width={488} height={99} style={{ width: 'auto' }} />
    </div>
  );
};

export default SlotifyLogo;
